import type { AdminAnalyticsReportFieldsFragment } from '~/api/graphql';
import {
  DEFAULT_ANALYTICS_AVG_ACCOUNT_PREMIUM,
  DEFAULT_ANALYTICS_HOURLY_RATE
} from './analytics-constants';
import type { AnalyticsAssumptions } from '~/components/settings/analytics/analytics-assumptions-picker';

type IncrementalRevenue = AdminAnalyticsReportFieldsFragment['incrementalRevenue'];

export function effectiveAssumptions(a: AnalyticsAssumptions): {
  hourlyRate: number;
  avgAccountPremium: number;
} {
  return {
    hourlyRate: a.hourlyRate ?? DEFAULT_ANALYTICS_HOURLY_RATE,
    avgAccountPremium: a.avgAccountPremium ?? DEFAULT_ANALYTICS_AVG_ACCOUNT_PREMIUM
  };
}

/**
 * Converts server-modeled expected incremental accounts into agency revenue dollars.
 */
export function computeIncrementalRevenueDollars(
  incrementalRevenue: IncrementalRevenue,
  avgAccountPremium: number
): number {
  return (
    incrementalRevenue.expectedIncrementalAccounts *
    avgAccountPremium *
    incrementalRevenue.commissionRate
  );
}

/** Format a fractional close likelihood as a percentage for display. */
export function formatCloseLikelihoodPercent(likelihood: number): string {
  const pct = likelihood * 100;
  if (pct % 1 === 0) {
    return `${pct.toFixed(0)}%`;
  }
  return `${pct.toFixed(1)}%`;
}
